import { Component, Inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Component({
    selector: 'add-files',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class AddFiles implements OnInit {
  public form: FormGroup;
  public allowMultpleUpload = true;
  public allowFiles = true;

  constructor(
    protected dialogRef: MatDialogRef<AddFiles>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private sanitizer: DomSanitizer,
    private SnackBar: MatSnackBar
  ) {
    this.allowMultpleUpload = data['allowMultpleUpload'];
    if (data['allowFiles'] !== undefined) {
      this.allowFiles = data['allowFiles'];
    }
  }

  get files() {
    return this.form.get('files') as FormArray;
  }

  ngOnInit() {
    const formBuilder = new FormBuilder();

    this.form = formBuilder.group({
      files: formBuilder.array([], [Validators.required]),
    });
  }

  onSubmit() {
    const formValue = this.form.getRawValue();
    this.dialogRef.close({ files: formValue.files || [] });
  }

  public fileUpload(event: any) {
    const fileList: FileList = event.target.files;

    this.fileChange(fileList);
  }

  public fileChange(fileList: FileList) {
    if (fileList.length > 0) {
      for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i];
        const isImage = file.type.includes('image');

        if (isImage) {
          const reader = new FileReader();
          reader.onload = (event: any) => {
            this.addFiles(event.target.result, file.name, file.type, file);
          };
          reader.readAsDataURL(file);
        } else {
          // For non-images, you don't need FileReader
          this.addFiles(null, file.name, file.type, file);
        }
      }
    }
  }

  public removeFile(file: AbstractControl) {
    const index = this.files.controls.indexOf(file);

    this.files.removeAt(index);
  }

  private addFiles(src: any, name: string, type: string, fileObj?: File) {
    const isImage = type && type.startsWith('image/');
    const blobUrl = !isImage
      ? this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(fileObj))
      : this.sanitizer.bypassSecurityTrustUrl(
          URL.createObjectURL(new Blob([src], { type }))
        );

    if (!this.allowFiles && !isImage) {
      const snackConfig: MatSnackBarConfig = new MatSnackBarConfig();
      snackConfig.duration = 5000;
      snackConfig.panelClass = ['error'];
      this.SnackBar.open('Please upload an image', 'Close', snackConfig);
      return;
    }

    const _src = !isImage ? fileObj : src;

    this.files.push(
      new FormBuilder().control({
        src: _src, // ✅ Use the real File object for uploading
        name,
        type,
        blobUrl,
        isImage,
        file: fileObj,
      })
    );
  }
}
